module.exports = __webpack_public_path__ + "static/media/AgentStateTransfer.93347940.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Images/EstadoAgente/AgentStateTransfer.svg
// module id = 1766
// module chunks = 0